const data = [{
    "barcelona": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/barcelona-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/barcelona-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/barcelona-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/barcelona-pobla-desktop.jpg"
      },
      "nombre": "Barcelona"
    }
  },
  {
    "bilbao": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/bilbao-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/bilbao-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/bilbao-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/bilbao-pobla-desktop.jpg"
      },
      "nombre": "Bilbao"
    }
  },
  {
    "cordoba": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/cordoba-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/cordoba-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/cordoba-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/cordoba-pobla-desktop.jpg"
      },
      "nombre": "Córdoba"
    }
  },
  {
    "gijon": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/gijon-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/gijon-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/gijon-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/gijon-pobla-desktop.jpg"
      },
      "nombre": "Gijón"
    }
  },
  {
    "laspalmas": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/laspalmas-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/laspalmas-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/laspalmas-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/laspalmas-pobla-desktop.jpg"
      },
      "nombre": "Las Palmas de G.C."
    }
  },
  {
    "madrid": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/madrid-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/madrid-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/madrid-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/madrid-pobla-desktop.jpg"
      },
      "nombre": "Madrid"
    }
  },
  {
    "malaga": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/malaga-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/malaga-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/malaga-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/malaga-pobla-desktop.jpg"
      },
      "nombre": "Málaga"
    }
  },
  {
    "murcia": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/murcia-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/murcia-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/murcia-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/murcia-pobla-desktop.jpg"
      },
      "nombre": "Murcia"
    }
  },

  {
    "palma": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/palma-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/palma-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/palma-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/palma-pobla-desktop.jpg"
      },
      "nombre": "Palma"
    }
  },

  {
    "sevilla": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/sevilla-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/sevilla-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/sevilla-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/sevilla-pobla-desktop.jpg"
      },
      "nombre": "Sevilla"
    }
  },
  {
    "valencia": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/valencia-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/valencia-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/valencia-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/valencia-pobla-desktop.jpg"
      },
      "nombre": "Valencia"
    }
  },
  {
    "valladolid": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/valladolid-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/valladolid-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/valladolid-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/valladolid-pobla-desktop.jpg"
      },
      "nombre": "Valladolid"
    }
  },
  {
    "vigo": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/vigo-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/vigo-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/vigo-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/vigo-pobla-desktop.jpg"
      },
      "nombre": "Vigo"
    }
  },
  {
    "zaragoza": {
      "renta": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/zaragoza-renta-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/zaragoza-renta-desktop.jpg"
      },
      "pobla": {
        "mobile": "https://lab.eldiario.es/estaticos/renta-inmigracion/zaragoza-pobla-mobile.jpg",
        "desktop": "https://lab.eldiario.es/estaticos/renta-inmigracion/zaragoza-pobla-desktop.jpg"
      },
      "nombre": "Zaragoza"
    }
  }
];

export default data;